const weekDays = ["日", "月", "火", "水", "木", "金", "土"];
// unixtime → 2022/4/11(月)
export const printFullDate = (unixtime) => {
    const date = new Date(unixtime * 1000);
    return `${date.getFullYear()}/${date.getMonth() + 1}/${date.getDate()}(${weekDays[date.getDay()]})`;
};
// unixtime → 4/11(月)
export const printDate = (unixtime) => {
    const date = new Date(unixtime * 1000);
    return `${date.getMonth() + 1}/${date.getDate()}(${weekDays[date.getDay()]})`;
};
// unixtime → 11:01
export const printTime = (unixtime) => {
    const date = new Date(unixtime * 1000);
    const h = date.getHours().toString().padStart(2, "0");
    const m = date.getMinutes().toString().padStart(2, "0");
    return `${h}:${m}`;
};
